import Header from '../components/Header';
import Footer from '../components/Footer';
import Contact from '../components/Contact';
import SEO from '../components/SEO';
import StructuredData from '../components/StructuredData';
import StarField from '../components/StarField';
import './Enquiries.css';

export default function Enquiries() {

  return (
    <>
      <SEO
        title="Get In Touch"
        description="Contact Kids Vids to discuss your family video editing project. Leave your details and we'll get back to you shortly. Based in Adelaide, serving families across Australia."
        path="/enquiries"
      />
      <StructuredData type="enquiries" />
      <Header />
      <main>
        <div className="enquiries-body film-strip">
          <div className="enquiries-background"></div>
          {/* Dark gradients to match Hero section */}
          <div className="gradient-overlay-radial"></div>
          <div className="gradient-overlay-top"></div>

          {/* Floating stars for ambience */}
          <StarField starCount={75} containerClassName="enquiries-hero-stars" />

          <div className="enquiries-content">
          <Contact 
            title="Get In Touch" 
            subline="Leave your contact details below and we'll get back to you shortly." 
            buttonText="Submit"
            titleAlignment="center"
          />
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
